// src/features/RADLayout/components/PrintableDiagram.jsx
import React, { useEffect } from "react";
import { useRadDiagram } from "../hooks/useRADDiagram.js";

const PrintableRAD = ({
  rad,
  diagramClass = "rad-diagram-container",
  onBackgroundClick,
  onClick,
  handleMove,
  selectedComponent,
  isConnecting,
  isLooping,
  isMerging,
  showTargets,
  dragEnabled = true, // BigDiagram will set this to false
  viewBoxWidth = 750,
  viewBoxHeight = 1000,
  minScale = 0.1,
  maxScale = 3,
  onZoomApi, // optional callback to hand zoom handlers to parent
}) => {
  const { containerRef, zoomApi } = useRadDiagram({
    rad,
    onBackgroundClick,
    onClick,
    handleMove,
    selectedComponent,
    isConnecting,
    isLooping,
    isMerging,
    showTargets,
    viewBoxWidth,
    viewBoxHeight,
    minScale,
    maxScale,
    dragEnabled,
  });

  useEffect(() => {
    if (onZoomApi) onZoomApi(zoomApi);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoomApi]);

  const title = rad?.info?.name || "";

  return (
    <div className="printable">
      <div className="print-section no-page-break">
        <div className={diagramClass} aria-label={title} ref={containerRef} />
      </div>
    </div>
  );
};

export default React.memo(PrintableRAD);
